import React from 'react'
import { Link, useLocation } from "react-router-dom";
import { authStore } from '../store/authStore';
import { useNoticeList } from "../utils/useNotice";

function Footer() {
  const { isLogin } = authStore();
  const location = useLocation();



  // 한번에 불러올 공지사항 갯수
  const SIZE = 10;
  const { noticeList, totalElements } = useNoticeList({ size: SIZE, page: 1 });



  return (
    // 숏폼 페이지일 때에는 footer 숨김
    !location.pathname.includes("/shortform/") && (
      <>
        <footer className="footer">
          {noticeList?.length > 0 ? (
            <div style={{ backgroundColor: "#040604" }}>
              <div className="container">
                <div className="row gx-2 gx-sm-2 gx-md-3">
                  <div className="col-12 col-md-12 col-xxl-12 mx-auto">
                    <div className="notice">
                      {isLogin && (
                        <>
                          <Link to="/notice">
                            <span>공지사항</span>
                          </Link>
                          <Link to={`/notice/${noticeList[0]?.id}`} state={{ noticeList: noticeList, currentIndex: 0, totalElements: totalElements }}>
                            {noticeList[0]?.title}
                          </Link>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="container">
            <div className="row gx-2 gx-sm-2 gx-md-3">
              <div className="col-12 col-md-12 col-xxl-12 mx-auto">
                <div className="info">
                  <p>룰루플레이TV에서 서비스하는 모든 영상은 영상물등급위원회에서 심의 과정을 의거하여 제작된 합법적인 콘텐츠입니다.</p>
                  <div className="footer-info-wrap">
                    <div>
                      <span>주식회사 호윤</span>
                      <br />
                      <span>
                        주소 : 서울특별시 강남구 선릉로 93길 40, 2층 206호
                        <br />
                        (역삼동, 스파크플러스)
                      </span>
                      <br />
                      <span>대표 : 조지연</span>
                      <br />
                      <span>사업자등록번호 : 261-81-24299</span>
                    </div>
                  </div>
                  <div className="link">
                    <Link to="/terms">이용약관</Link>
                    <Link to="/privacy-policy">개인정보취급방침</Link>
                    <Link to="/support">고객센터</Link>
                    {/* <Link to="/copyright-policy">저작권 보호센터</Link> */}
                    <Link to="/teenager-policy">청소년 보호정책</Link>
                  </div>
                  <i>Copyright ©luluplay All rights reserved.</i>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    )
  );
}

export default React.memo(Footer);